import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireCIS: QuestionnaireFlowType = {
    id: FindingAreasEnum.ConstructionIndustryScheme,
    name: getFindingAreaDisplayText(FindingAreasEnum.ConstructionIndustryScheme),
    questions: [
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q1`,
            text: "Are you a mainstream contractor for the purposes of the Construction Industry Scheme (\"CIS\") - meaning, is your trade to carry out construction work or supply labour for construction work?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ConstructionIndustryScheme}:Q2A`,
                no: `${FindingAreasEnum.ConstructionIndustryScheme}:Q2B`,
            },
        },
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q2A`,
            text: "Are you registered with HMRC as a contractor for CIS?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ConstructionIndustryScheme}:Q3A`,
                no: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q2B`,
            text: "Have any entities spent more than £3m in any 12-month period on construction work?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ConstructionIndustryScheme}:Q3B`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q3A`,
            text: "Are your filings and payments up to date?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q3B`,
            text: "Are you registered with HMRC as a contractor for CIS?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ConstructionIndustryScheme}:Q4A`,
                no: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.ConstructionIndustryScheme}:Q4A`,
            text: "Are filings and payments up to date?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber,
            },
        }
    ],
};

export default questionnaireCIS;
